module.exports = __webpack_public_path__ + "static/media/insight-2.63357813.jpg";